module.exports = __webpack_public_path__ + "content/065f81ed54807b99071993ed51048e75.png";